// @flow
import React from 'react';
import { Box, CircularProgress } from '@mui/material';

const compactSx = {
  minHeight: 'auto',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '12px 16px',
  width: '100%',
  boxSizing: 'border-box',
};

type Props = {
  minHeight?: string,
  compact?: boolean,
  fullViewport?: boolean,
};

const PageLoadingFallback = ({ minHeight, compact, fullViewport }: Props) => {
  if (compact) {
    return (
      <Box sx={compactSx} className="page-loading-fallback page-loading-fallback--compact">
        <CircularProgress size={40} />
      </Box>
    );
  }

  const fillAppBody =
    minHeight == null && !fullViewport;

  return (
    <Box
      className="page-loading-fallback"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 2,
        width: '100%',
        boxSizing: 'border-box',
        ...(fullViewport && { minHeight: '100vh' }),
        ...(minHeight != null && { minHeight }),
        ...(fillAppBody && {
          flex: 1,
          minHeight: 0,
          alignSelf: 'stretch',
        }),
      }}
    >
      <CircularProgress size={40} />
    </Box>
  );
};

export default PageLoadingFallback;
